import _loginPageStore from './login/login-page.store';
import _docPageStore from './doc/doc-page.store';
import {combineReducers} from "redux";

const reducers = combineReducers({
    loginPage: _loginPageStore,
    doc: _docPageStore
})

export default reducers